var _path, _path2, _path3, _path4, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 83,
    height: 26,
    viewBox: "0 0 83 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M55.4432 18.828C54.5576 18.276 53.115 17.3831 52.6077 17.1055C48.7931 20.3476 46.1481 17.6182 46.0987 15.8195H56.6573C56.726 15.4093 56.7624 14.9881 56.7624 14.5582C56.7624 10.3789 53.3742 6.99072 49.1949 6.99072C45.0154 6.99072 41.6273 10.3789 41.6273 14.5582C41.6273 18.7377 45.0154 22.1259 49.1949 22.1259C51.7902 22.1259 54.0801 20.8191 55.4432 18.828ZM46.0987 12.9509C46.2723 11.3984 47.5981 10.181 49.1949 10.181C50.7916 10.181 52.1174 11.3984 52.291 12.9509H46.0987ZM34.7709 15.2804L37.7744 7.52042H42.5103L36.3246 21.6512H33.217L27.0315 7.52042H31.7673L34.7709 15.2804ZM65.1138 7.24268C65.0366 7.25032 64.9583 7.25883 64.8776 7.26967C63.1161 7.50564 62.1171 8.62832 62.1171 8.62832L61.6279 7.52043H57.9855V21.6512H62.2539V15.1832V15L62.2543 14.9821C62.2658 14.3922 62.2958 12.8628 63.8723 11.782C64.9075 11.0722 66.0886 11.1777 66.9488 11.4197L65.1138 7.24268ZM74.5738 15.2804L77.5773 7.52042H82.3131L76.1276 21.6512H73.02L66.8345 7.52042H71.5703L74.5738 15.2804Z",
    fill: "#15153A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.0988 17.7715C9.66897 19.8628 9.36264 23.4977 11.3714 25.9697V25.9697L20.8629 17.812C23.2929 15.7208 23.5992 12.0859 21.5902 9.61377V9.61377L12.0988 17.7715Z",
    fill: "url(#paint0_linear_1439_204)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.1077 0L6.9164 12.2093C4.48657 14.3006 4.18024 17.9354 6.18914 20.4075V20.4075L8.20618 22.7499C8.18129 22.3586 8.18449 21.9633 8.21936 21.5662V21.5662C8.39631 19.5388 9.34365 17.6908 10.8875 16.3621V16.3621L20.3803 8.19826C22.8103 6.10692 23.1166 2.47209 21.1077 0Z",
    fill: "url(#paint1_linear_1439_204)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.0508 6.55963C0.694114 7.72716 -0.000492629 9.37601 2.62131e-07 11.0348V11.0348V11.0382C0.00110927 12.3495 0.436825 13.6669 1.32341 14.7579V14.7579L3.09289 16.8129C3.09264 16.5816 3.10139 16.3494 3.12173 16.1165V16.1165C3.29917 14.0859 4.24798 12.2351 5.79356 10.9048V10.9048L8.51334 8.56495C10.8907 6.46623 11.1793 2.87096 9.18626 0.418457V0.418457L2.0508 6.55963Z",
    fill: "url(#paint2_linear_1439_204)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1439_204",
    x1: 22.9137,
    y1: 9.61377,
    x2: 10.0481,
    y2: 9.61377,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF00CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#333399"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1439_204",
    x1: 22.4311,
    y1: 0,
    x2: 4.86572,
    y2: 0,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF00CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#333399"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1439_204",
    x1: 10.5085,
    y1: 0.418457,
    x2: 0,
    y2: 0.418457,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF00CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#333399"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.617af2820862a88d2d555d8f73df2947.svg";
export { ForwardRef as ReactComponent };